export const APP_ROUTES = [
  {
    path: '/ai-text-generator',
    label: 'Chat Tradicional (igual ao ChatGPT)'
  },
  {
    path: '/student-chat',
    label: 'Assistente do Estudante'
  },
  {
    path: '/teacher-chat',
    label: 'Assistente do Professor(a)'
  },
  {
    path: '/employee-tool',
    label: 'Ferramenta do(a) Funcionário(a)'
  },
  {
    path: '/entrepreneur-tool',
    label: 'Ferramenta do(a) Empreendedor(a)'
  },
  {
    path: '/health-improvement',
    label: 'Melhore sua Saúde'
  },
  {
    path: '/language-coach',
    label: 'Professor de Idiomas'
  },
  {
    path: '/golden-solution',
    label: 'Solução de Ouro'
  },
  {
    path: '/atendimento-premium',
    label: 'Atendimento Premium'
  },
  {
    path: '/portal',
    label: 'Página Inicial'
  }
];